<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin:0; padding:0; }
body, button, input, select, textarea { font:12px/1.5tahoma, arial, 5b8b4f53; }
h1, h2, h3, h4, h5, h6{ font-size:100%; }
address, cite, dfn, em, var { font-style:normal; }
code, kbd, pre, samp { font-family:couriernew, courier, monospace; }
small{ font-size:12px; }
ul, ol { list-style:none; }
a { text-decoration:none; }
a:hover { text-decoration:underline; }
sup { vertical-align:text-top; }
sub{ vertical-align:text-bottom; }
legend { color:#000; }
fieldset, img { border:0; }
button, input, select, textarea { font-size:100%; }
table { border-collapse:collapse; border-spacing:0; }
#app {
    font-size: 62.5%;
    line-height: 1;
    font-family: Arial, Tahoma, sans-serif;
    height: 100vh;
}
.el-scrollbar .el-scrollbar__bar {
    opacity: 1 !important;
}
/* 思源黑体 Medium */
@font-face {
  font-family: 'CustomFont1';
  src: url('~@/assets/font/fons_1.otf');
}
/* 思源宋体 heavy */
@font-face {
  font-family: 'CustomFont2';
  src: url('~@/assets/font/fons_2.otf');
}
@font-face {
  font-family: 'CustomFont3';
  src: url('~@/assets/font/fons_3.ttf') format('truetype');
}
@font-face {
  font-family: 'CustomFont4';
  src: url('~@/assets/font/pan.ttf');
}
/* 思源黑体 Medium */
@font-face {
  font-family: 'CustomFont5';
  src: url('~@/assets/font/siyuanS.otf');
}
/* 思源宋体 Heavy */
@font-face {
  font-family: 'CustomFont6';
  src: url('~@/assets/font/siyuanH.otf');
}
@font-face {
  font-family: 'CustomFont7';
  src: url('~@/assets/font/huakang.ttf') format('truetype');
}
</style>



// WEBPACK FOOTER //
// src/App.vue